import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-filter-debtor-black-list',
  templateUrl: './filter-debtor-black-list.component.html',
  styleUrls: ['./filter-debtor-black-list.component.scss']
})
export class FilterDebtorBlackListComponent {
  @Output() geFilter: EventEmitter<string> = new EventEmitter();
  public formFilter!: FormGroup;

  constructor(private fb: FormBuilder) {
    this.formFilter = this.fb.group({
      generalFilter: [''],
    });
  }
  
  filtroGeneral(event: any) {
    const filterValue = event.target.value;
    this.geFilter.emit(filterValue);
  }

  filtroGeneralTemporizado(event: any) {
    setTimeout(() => {
      const filterValue = event.target.value;
      this.geFilter.emit(filterValue);
    }, 2000);
  }
  
}
